import { NavigationFinance } from "@components/widgets/AppSubNav";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { InvoicingPlanAutomatedList } from "@src/components/modules/invoicing-plan/automated-list";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => (
  <MainLayout title={t`Invoicing plan`} navigation={<NavigationFinance />}>
    <InvoicingPlanAutomatedList />
  </MainLayout>
);

export const Route = createFileRoute("/invoices/invoicing-plan/automated")({
  component: Page,
});
